import React, { memo } from 'react';
import { Circle, useTheme, Button } from 'tamagui';

import { CobuStack, CobuText } from '@cobu/ui';
import { MemberOverflowProps, GROUP_MEMBERS_CONSTANTS } from '@cobu/types';
import { Strings } from '../../constants';


const MemberOverflow: React.FC<MemberOverflowProps> = memo(({
  count,
  index,
  size = GROUP_MEMBERS_CONSTANTS.DEFAULT_AVATAR_SIZE,
  isGlobalChat = false,
  onPress,
}) => {
  const theme = useTheme();
  const strings = Strings.get().groupMembers;

  // Calculate position with overlap effect
  const leftOffset = index * GROUP_MEMBERS_CONSTANTS.OVERLAP_OFFSET;

  // Determine styling based on context
  const backgroundColor = '$buttonBackground';

  const textColor = '$buttonText';

  // Handle press action
  const handlePress = () => {
    if (onPress) {
      onPress();
    }
  };

  // Format overflow text
  const overflowText = count > 99 ? '99+' : `+${count}`;

  return (
    <CobuStack layout='horizontal'
      style={{
        position: 'relative',
        left: leftOffset,
        zIndex: 1000 + index,
      }}
    >
      <Button
        onPress={onPress ? handlePress : undefined}
        disabled={!onPress}

        // activeOpacity={onPress ? 0.8 : 1}
        style={{
          width: size,
          height: size,
        }}
      >
        <Circle
          size={size}
          bc={backgroundColor}
          jc="center"
          ai="center"
          ov="hidden"
        >
          <CobuText
            variant="body"
            color={textColor}
          >
            {overflowText}
          </CobuText>
        </Circle>
      </Button>
    </CobuStack>
  );
});

MemberOverflow.displayName = 'MemberOverflow';

export default MemberOverflow; 